import jyRequest from "../utils/axios";

export function publishItem(data) {
  return jyRequest.post({
    url: 'api/prjIntro/addProject',
    data: data,
    headers: {
      Authorization: JSON.parse(localStorage.getItem('loginstate'))?.accessToken
    }
  })
}

export function getList(data) {
  return jyRequest.get({
    url: 'api/prjIntro/getProjectIndexList',
    params: data,
  })
}

export function getDetail(data) {
  return jyRequest.post({
    url: 'api/prjIntro/getProjectById',
    data: data,
  })
}

export function getTypeList(data) {
  return jyRequest.post({
    url: 'api/prjIntro/getProjectList',
    data: data,
  })
}

export function getMine(data) {
  return jyRequest.post({
    url: 'api/prjIntro/getProjectListById',
    data: data,
    headers: {
      Authorization: JSON.parse(localStorage.getItem('loginstate'))?.accessToken
    }
  })
}

export function updateList(data) {
  return jyRequest.post({
    url: 'api/prjIntro/updateProjectById',
    data: data,
    headers: {
      Authorization: JSON.parse(localStorage.getItem('loginstate'))?.accessToken
    }
  })
}

export function getToken(data) {
  return jyRequest.get({
    url: 'api/sys/getUploadToken',
    params: data,
    headers: {
      Authorization: JSON.parse(localStorage.getItem('loginstate'))?.accessToken
    }
  })
}

export function deleteById(id) {
  return jyRequest.get({
    url: `api/prjInaliPayPcRechargetro/deleteProjectById/${id}`,
    headers: {
      Authorization: JSON.parse(localStorage.getItem('loginstate'))?.accessToken
    }
  })
}

export function getCommonToken(data) {
  return jyRequest.get({
    url: 'api/sys/getUploadTokenCommon',
    params: data,
  })
}

export function aliPayPcRecharge(data) {
  return jyRequest.post({
    url: 'api/aliPayPc/recharge',
    data: data,
    headers: {
      Authorization: JSON.parse(localStorage.getItem('loginstate'))?.accessToken
    }
  })
}

export function aliPayPcRechargeList(data) {
  return jyRequest.post({
    url: 'api/aliPayPc/rechargeList',
    data: data,
    headers: {
      Authorization: JSON.parse(localStorage.getItem('loginstate'))?.accessToken
    }
  })
}
